__turbopack_context__.v({
  "dot": "NewsMediaCarousel-module-scss-module__3BZkfa__dot",
  "dotActive": "NewsMediaCarousel-module-scss-module__3BZkfa__dotActive",
  "dots": "NewsMediaCarousel-module-scss-module__3BZkfa__dots",
  "image": "NewsMediaCarousel-module-scss-module__3BZkfa__image",
  "nav": "NewsMediaCarousel-module-scss-module__3BZkfa__nav",
  "navButton": "NewsMediaCarousel-module-scss-module__3BZkfa__navButton",
  "navButtonInactive": "NewsMediaCarousel-module-scss-module__3BZkfa__navButtonInactive",
  "navIcon": "NewsMediaCarousel-module-scss-module__3BZkfa__navIcon",
  "navIconRight": "NewsMediaCarousel-module-scss-module__3BZkfa__navIconRight",
  "root": "NewsMediaCarousel-module-scss-module__3BZkfa__root",
  "slide": "NewsMediaCarousel-module-scss-module__3BZkfa__slide",
  "swiper": "NewsMediaCarousel-module-scss-module__3BZkfa__swiper",
  "viewport": "NewsMediaCarousel-module-scss-module__3BZkfa__viewport",
});
